import React, { Component } from 'react';
import { ReactComponent as IconArrow } from '../../media/icons/arrow_right.svg';


export default class Valueprop extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Default states
            page: 1,
            page_count: 5,
            clicked: false
        };

        this.setPage = this.setPage.bind(this);
    }

    componentDidMount() {
        this.intervalId = setInterval(() => {
            if (this.state.clicked === false) {
                this.setState({
                    page: (this.state.page + 1 > this.state.page_count ? 1 : this.state.page + 1)
                });
            }
        }, 3000);
    }


    componentWillUnmount() {
        clearInterval(this.intervalId);
    }


    setPage(page) {
        var page = page > this.state.page_count ? 1 : (page < 1 ? this.state.page_count : page);
        this.setState({
            page: page,
            clicked: true
        });
    }


    render() {

        return (
            <div className="home__valueprop-container">
                <div className="home__valueprop__background">
                    <div className="home__valueprop__background__top"></div>
                    <div className="home__valueprop__background__top-overlay"></div>
                    <div className="home__valueprop__background__mid"></div>
                    <div className="home__valueprop__background__bottom"></div>
                    <div className="home__valueprop__background__bottom-overlay"></div>
                </div>
                <div className="content-wrapper--wide home__valueprop-wrapper">

                    <div className="home__valueprop__element-container">
                        <h2 className="home__valueprop__title text-title text-centered text-color-light">
                            Why travelers choose Guidr
                        </h2>

                        <div className={"home__valueprop__element-wrapper" + (this.state.page === 1 ? " home__valueprop__element--active" : "")}>
                            <div className="home__valueprop__element__background">
                                <img src={"https://guidr-media.s3.us-east-1.amazonaws.com/static-files/home/value-prop/beach.webp"} alt={""} className={"home__valueprop__element__background-inner"} />
                            </div>
                            <div className="home__valueprop__contentbox">
                                <h3 className="home__valueprop__contentbox__title text-title">
                                    🗺️ Expert-Curated Itineraries
                                </h3>
                                <div className="home__valueprop__contentbox__textbox">
                                    Get access to detailed travel plans crafted by locals and experienced travelers who know the best spots.
                                </div>
                            </div>
                        </div>
                        <div className={"home__valueprop__element-wrapper" + (this.state.page === 2 ? " home__valueprop__element--active" : "")}>
                            <div className="home__valueprop__element__background">
                                <img src={"https://guidr-media.s3.us-east-1.amazonaws.com/static-files/home/value-prop/desert.webp"} alt={""} className={"home__valueprop__element__background-inner"} />
                            </div>
                            <div className="home__valueprop__contentbox">
                                <h3 className="home__valueprop__contentbox__title text-title">
                                    ✨ Unique & Hidden Gems
                                </h3>
                                <div className="home__valueprop__contentbox__textbox">
                                    Discover off-the-beaten-path experiences that guidebooks and generic travel blogs often miss.
                                </div>
                            </div>
                        </div>
                        <div className={"home__valueprop__element-wrapper" + (this.state.page === 3 ? " home__valueprop__element--active" : "")}>
                            <div className="home__valueprop__element__background">
                                <img src={"https://guidr-media.s3.us-east-1.amazonaws.com/static-files/home/value-prop/safari.webp"} alt={""} className={"home__valueprop__element__background-inner"} />
                            </div>
                            <div className="home__valueprop__contentbox">
                                <h3 className="home__valueprop__contentbox__title text-title">
                                    📍 Tailored for Every Traveler
                                </h3>
                                <div className="home__valueprop__contentbox__textbox">
                                    Find itineraries based on your interests—adventure, food, culture, or relaxation—customized for different budgets and travel styles.
                                </div>
                            </div>
                        </div>
                        <div className={"home__valueprop__element-wrapper" + (this.state.page === 4 ? " home__valueprop__element--active" : "")}>
                            <div className="home__valueprop__element__background">
                                <img src={"https://guidr-media.s3.us-east-1.amazonaws.com/static-files/home/value-prop/rainforest.webp"} alt={""} className={"home__valueprop__element__background-inner"} />
                            </div>
                            <div className="home__valueprop__contentbox">
                                <h3 className="home__valueprop__contentbox__title text-title">
                                    💡 Hassle-Free Planning
                                </h3>
                                <div className="home__valueprop__contentbox__textbox">
                                    Save hours of research with ready-to-use, step-by-step itineraries, complete with maps, must-visit spots, and insider tips.
                                </div>
                            </div>
                        </div>
                        <div className={"home__valueprop__element-wrapper" + (this.state.page === 5 ? " home__valueprop__element--active" : "")}>
                            <div className="home__valueprop__element__background">
                                <img src={"https://guidr-media.s3.us-east-1.amazonaws.com/static-files/home/value-prop/coast.webp"} alt={""} className={"home__valueprop__element__background-inner"} />
                            </div>
                            <div className="home__valueprop__contentbox">
                                <h3 className="home__valueprop__contentbox__title text-title">
                                    💰 Free & Premium Options
                                </h3>
                                <div className="home__valueprop__contentbox__textbox">
                                    Choose from a variety of free itineraries or unlock premium, in-depth guides for an exclusive travel experience.
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div onClick={() => this.setPage(this.state.page - 1)} className="home__valueprop__navbutton home__valueprop__navbutton--left">
                    <IconArrow className="home__valueprop__navbutton-inner" />
                </div>
                <div onClick={() => this.setPage(this.state.page + 1)} className="home__valueprop__navbutton home__valueprop__navbutton--right">
                    <IconArrow className="home__valueprop__navbutton-inner" />
                </div>
            </div>
        )
    }
}
